import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import phpSyntax1 from './assets/images/php-syntax1.png';
import phpSyntax2 from './assets/images/php-syntax2.png';
import echoPrint from './assets/images/echo-print.png';



const PhpLesson3 = () => {
    const [language, changeLanguage] = useState("php");
    const [lineNumbers, toggleLineNumbers] = useState(false);
    const code = (
      'text',
      `<?php
      // your PHP Code here
      ?>`
    );
    const code1 = (
      'text',
      `<!DOCTYPE html>
      <html>
      <head>
      <title>PHP Test</title>
      </head>
      <body>
      </php echo "Hello World!" ?>
      </body>
      </html>`
    );
    const code2 = (
      'text',
      `<?php
      echo "This is a string";
      echo "This is " . "a concantented string";

      print "This is a string";

      //The following statement will outout 2
      echo print "This is a string";
      ?>`
    );


  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">


    <div className="alert alert-secondary" role="alert">
    <h3><strong>PHP Syntax</strong></h3>
    <p>Here is a basic syntax for PHP code:</p>
    <CopyBlock
    language={"php"}
    text={code}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <br />
    <p>All PHP code must be enclosed within the opening and closing PHP tags. Anything outside these tags is treated as plain HTML.</p>
    <p>Here is an example of a simple PHP script that displays <b>"Hello, World!"</b> on a web page:</p>
    <CopyBlock
    language={"php"}
    text={code1}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <p>In above example, the PHP code is embedded within the HTML body.</p>
    <p>When the web page is requested by a user, the server executes the PHP code and returns the resulting output (in this case, <b>"Hello, World!"</b>) as part of the HTML page.</p>
    <p>The default file extension for PHP files is <b><i>.php</i></b>. </p><p>A PHP file normally contains HTML tags, and some PHP scripting code.</p>
    <p>Running the code from our localhost, we'll get <b>Hello World!</b> printed on the screen.</p>

    <p>In PHP, <b>echo</b> and <b>print</b> are both used to output data to the screen. The differences between them are small:</p>
      <ol class="list-group list-group-numbered mb-2">
     <li class="list-group-item"><b>echo</b> is slightly faster than <b>print</b>.</li>
      <li class="list-group-item"><b>echo</b> can take multiple parameters (although such usage is rare), whereas <b>print</b> can only take one argument.</li>
      <li class="list-group-item"><b>echo</b> does not return a value, whereas <b>print</b> returns 1.</li>
      </ol>
      <p>Here is an example of how to use <b>echo</b> and <b>print</b> in PHP:</p>
      <CopyBlock
      language={"php"}
      text={code2}
      showLineNumbers={lineNumbers}
      theme={dracula}
      wrapLines={true}
      codeBlock
      />

  </div>




    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default PhpLesson3
